import { defineStore } from 'pinia';
import type { BaseCustomer } from '@/types/customer';
import type { teamRecord } from '@/api/team';
import type { MessageInfo } from '@/api/report';

interface DrawerState {
  activeReportDrawer: boolean;
  activeCustomerDrawer: boolean;
  activeAddCustomerDrawer: boolean;
  activeReportMsgDrawer: boolean;
  reportParams: BaseCustomer | undefined;
  customerParams: BaseCustomer | null | undefined;
  addCustomerParams?: any;
  reportMsgId: number | undefined;
}

const useDrawerStore = defineStore('drawer', {
  state: (): DrawerState => ({
    activeReportDrawer: false,
    activeCustomerDrawer: false,
    activeAddCustomerDrawer: false,
    activeReportMsgDrawer: false,
    reportParams: undefined,
    customerParams: undefined,
    addCustomerParams: undefined,
    reportMsgId: undefined,
  }),
  actions: {
    openReportDrawer(params?: BaseCustomer) {
      this.reportParams = params;
      this.activeReportDrawer = true;
    },
    closeReportDrawer() {
      this.activeReportDrawer = false;
      setTimeout(() => {
        this.reportParams = undefined;
      }, 300); // 延迟清空参数，避免动画期间数据闪烁
    },
    openCustomerDrawer(params?: BaseCustomer | null) {
      this.customerParams = params;
      this.activeCustomerDrawer = true;
    },
    closeCustomerDrawer() {
      this.activeCustomerDrawer = false;
      setTimeout(() => {
        this.customerParams = undefined;
      }, 300);
    },
    openAddCustomerDrawer(params?: any) {
      this.addCustomerParams = params;
      this.activeAddCustomerDrawer = true;
    },
    closeAddCustomerDrawer() {
      this.activeAddCustomerDrawer = false;
      setTimeout(() => {
        this.addCustomerParams = undefined;
      }, 300);
    },
    openReportMsgDrawer(id?: number) {
      this.reportMsgId = id;
      this.activeReportMsgDrawer = true;
    },
    closeReportMsgDrawer() {
      this.activeReportMsgDrawer = false;
      setTimeout(() => {
        this.reportMsgId = undefined;
      }, 300);
    },
  },
});

export default useDrawerStore;
